<app-modal
  [(visible)]="visible"
  [header]="header"
  [width]="width"
  [showFooter]="false"
  (visibleChange)="handleVisibleChange($event)"
  (onClose)="handleVisibleChange(false)"
>
  <div class="tab-modal-content" [style.height]="height">
    <!-- Tabs -->
    <div class="modal-tabs" *ngIf="tabs.length > 0">
      <button 
        *ngFor="let tab of tabs"
        class="modal-tab" 
        [class.active]="activeTab === tab.key"
        (click)="setActiveTab(tab.key)"
      >
        {{ tab.label }}
      </button>
    </div>

    <!-- Tab Content -->
    <div class="tab-content">
      <ng-container *ngFor="let tab of tabs">
        <div 
          class="tab-pane" 
          *ngIf="activeTab === tab.key"
        >
          <ng-container *ngTemplateOutlet="tab.contentTemplate"></ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</app-modal>
